<template>
	<div class="display-flex flex-row flex-align-center">
		<ManageAndCreateTab class="ml-6" v-for="tab in filteredTabs" :key="tab.text" :tab="tab" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { FEATURE_FLAGS } from '@/utils/feature-toggle-service';
import { isFeatureOn, isAnalyticsTabEnabled, isIssuesManagementEnabled } from '@/store/modules/featureFlags/getters';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import { PROJECTS_SHARED_WITH_ME_VIRTUAL_ID } from '@/utils/projects.const';
import { ANALYTICS_ROUTE_NAME, BUTTON_DROPDOWN_ROUTE_NAME, ISSUES_ROUTE_NAME } from '@/router/router.const';
import ManageAndCreateTab from '@/views/AppLayout/ManageAndCreate/ManageAndCreateTab.vue';
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service.js';
export default {
	name: 'ManageAndCreateTabs',
	props: {
		hideTabs: { type: Boolean, default: false },
	},
	components: {
		ManageAndCreateTab,
	},
	computed: {
		...mapGetters([isFeatureOn.fullPath, isAnalyticsTabEnabled.fullPath, selectedProjectId.fullPath, isIssuesManagementEnabled.fullPath]),
		filteredTabs() {
			if (this.hideTabs) {
				return [];
			}
			return this.tabs.filter((tab) => tab.show);
		},
		isSelectedProjectsSharedProjects() {
			return this[selectedProjectId.fullPath] === PROJECTS_SHARED_WITH_ME_VIRTUAL_ID;
		},
		isPlacementMode() {
			return CreateAndManageService.isPlacementMode(this.$route);
		},
		isPlacementEverythingMode() {
			return CreateAndManageService.isPlacementEverythingMode(this.$route);
		},
		isPlacementAddOnMode() {
			return CreateAndManageService.isPlacementAddOnMode(this.$route);
		},
		showTaskLog() {
			return !this.isSelectedProjectsSharedProjects && (!this.isPlacementMode || this.isPlacementEverythingMode); //  in placement mode - show TaskLog only in everything mode
		},
		showIssues() {
			return (
				this.isIssuesManagementEnabled &&
				!this.isSelectedProjectsSharedProjects &&
				(!this.isPlacementMode || this.isPlacementEverythingMode)
			); //  in placement mode - show TaskLog only in everything mode
		},
		isAnalyticsTabEnabled() {
			return this[isAnalyticsTabEnabled.fullPath];
		},
		isIssuesManagementEnabled() {
			return this[isIssuesManagementEnabled.fullPath];
		},
		tabs() {
			return [
				{ text: 'Features', routeName: 'Features', show: true },
				{
					text: 'Connections',
					routeName: 'Connections',
					show:
						!this.isSelectedProjectsSharedProjects &&
						(!this.isPlacementMode || this.isPlacementEverythingMode || this.isPlacementAddOnMode), //  in placement mode - show connections only in everything and add-ons mode
				},
				{
					text: 'Analytics',
					show: this.isAnalyticsTabEnabled && this.showTaskLog, // synced with taskLog
					routeName: ANALYTICS_ROUTE_NAME,
				},
				{
					text: 'Task log',
					routeName: 'TaskLog',
					show: this.showTaskLog,
				},
				{
					text: 'Button dropdowns',
					routeName: BUTTON_DROPDOWN_ROUTE_NAME,
					show:
						!this.isSelectedProjectsSharedProjects &&
						(!this.isPlacementMode || this.isPlacementEverythingMode || this.isPlacementAddOnMode), //  in placement mode - show Button dropdowns only in everything and add-ons mode
				},
				{
					text: 'Issues',
					routeName: ISSUES_ROUTE_NAME,
					show: this.showIssues,
				},
				{
					text: 'Processes',
					routeName: 'Processes',
					show:
						!this.isSelectedProjectsSharedProjects &&
						!this.isPlacementEverythingMode &&
						this.isFeatureFlagOn(FEATURE_FLAGS.ALLOW_PROCESSES),
				},
				{
					text: 'Reports',
					routeName: 'ProcessReports',
					show:
						!this.isSelectedProjectsSharedProjects &&
						!this.isPlacementEverythingMode &&
						this.isFeatureFlagOn(FEATURE_FLAGS.ALLOW_PROCESSES),
				},
			];
		},
	},
	methods: {
		isFeatureFlagOn(featureFlag) {
			if (!featureFlag) {
				return true;
			}
			return !!this[isFeatureOn.fullPath](featureFlag);
		},
	},
};
</script>
<style scoped lang="scss">
.bar-container {
	height: 70px;
	background: var(--bg-color);
	border-bottom: 1px solid var(--tertiary-border-color);
}
</style>
